module.exports = __webpack_public_path__ + "img/08.d535190d.png";